import React from "react";
import { PAGE_SHELL, PAGE_HEADER_ROW, PAGE_SUBTITLE } from "../../ui/pageChrome";
import { BRAND_THEME } from "../../ui/brandTheme";
import { ShieldCheckIcon } from "../../Icons";

/**
 * QA Center module is temporarily disabled for all roles.
 * Sidebar entry stays visible with a Coming Soon affordance.
 */
const QaCenter = () => (
  <div className={PAGE_SHELL}>
    <div className={PAGE_HEADER_ROW}>
      <div>
        <h1 className={`text-2xl font-bold ${BRAND_THEME.section.title}`}>
          QA Center
        </h1>
        <p className={PAGE_SUBTITLE}>
          Review clinical notes and quality flags across the agency
        </p>
      </div>
    </div>

    <div className="flex flex-col items-center justify-center rounded-xl border border-slate-200 bg-white px-6 py-20 text-center shadow-sm">
      <span className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-slate-400">
        <ShieldCheckIcon size={28} />
      </span>
      <p className="mt-4 text-lg font-semibold text-slate-800">Coming Soon</p>
      <p className="mt-1.5 max-w-sm text-sm text-slate-500">
        The QA Center module is temporarily unavailable. Check back later.
      </p>
    </div>
  </div>
);

export default QaCenter;
